import { gql } from "apollo-boost";


export const GET_SHOP = gql`
query Shop($where: ShopWhereInputOne!) {
    shop(where: $where) {
      id
      users {
        firstName
        username
        lastName
        nickname
        gender
        role
        createdAt
      }
      point
      name
      address {
        district
        province
        village
      }
      owner {
        nickname
        lastName
        username
      }
      note
      phone
      phoneSeconde
      image
      isLessStocks
      isBillNumber
      isBillOfferPrice
      descriptionPOSBill
      businessNumber
      isPaymentGateway
    }
  }
  
`


export const GET_CUSTOM_THEME = gql`
query Data($where: ThemeWhereInput!) {
  customTheme(where: $where) {
    data {
      id
      customTheme
      customerScreen
      counterScreen
      shop
      note
      isTitleCms
      isBannerCms
      isTitleBannerCms
      isRateCms
      isTextMarqueeCms
      createdAt
      updatedAt
    }
  }
}
`

export const GET_PROMOTIONS = gql`
query Data($where: PromotionWhereInput) {
  getPromotions(where: $where) {
    data {
      id
      name
      discount
      discountType
      image
      isDeleted 
      createdBy
      updatedBy
      startDate
      endDate
      note
      status
    }
  }
}
`
